import { Translation } from 'hooks/useTranslation/useTranslation';
import { FilterSection } from 'v2/components/SearchAndFilters/SearchAndFilters';
import { filterStatusDefault } from './cardFilterConstants';
import { AccessCardsFilterState, FilterAssignedState, FilterValidity } from './cardFilterTypes';

interface Params {
  translation: Translation;
  filters: AccessCardsFilterState;
}

export const createCardFilterSections = ({ translation, filters }: Params): FilterSection[] => {
  const { filterStatus, filterValidity, filterAssigned } = filters.filter;
  const { setFilterStatus, setFilterValidity, setFilterAssigned } = filters.setters;

  return [
    {
      id: 'status',
      header: translation.status,
      type: 'checkbox',
      isClearDisabled: !Object.values(filterStatus).some(Boolean),
      onClear: () => setFilterStatus(filterStatusDefault),
      items: [
        {
          key: 'cardBlocked',
          label: translation.card_blocked,
          checked: filterStatus.cardBlocked,
          onChange: () => setFilterStatus((current) => ({ ...current, cardBlocked: !current.cardBlocked }))
        },
        {
          key: 'userDeleted',
          label: translation.user_deleted,
          checked: filterStatus.userDeleted,
          onChange: () => setFilterStatus((current) => ({ ...current, userDeleted: !current.userDeleted }))
        },
        {
          key: 'cardExpired',
          label: translation.card_expired,
          checked: filterStatus.cardExpired,
          onChange: () => setFilterStatus((current) => ({ ...current, cardExpired: !current.cardExpired }))
        },
        {
          key: 'accessRightsChanged',
          label: translation.access_rights_changed,
          checked: filterStatus.accessRightsChanged,
          onChange: () =>
            setFilterStatus((current) => ({ ...current, accessRightsChanged: !current.accessRightsChanged }))
        },
        {
          key: 'userExpiresSoon',
          label: translation.user_expires_soon,
          checked: filterStatus.userExpiresSoon,
          onChange: () => setFilterStatus((current) => ({ ...current, userExpiresSoon: !current.userExpiresSoon }))
        }
      ]
    },
    {
      id: 'validity',
      header: translation.card_validity_expires_in,
      type: 'radio',
      isClearDisabled: filterValidity === null,
      onClear: () => setFilterValidity(null),
      items: [
        {
          key: FilterValidity.OneDay,
          label: translation[FilterValidity.OneDay],
          checked: filterValidity === FilterValidity.OneDay,
          onChange: () => setFilterValidity(FilterValidity.OneDay)
        },
        {
          key: FilterValidity.ThreeDays,
          label: translation[FilterValidity.ThreeDays],
          checked: filterValidity === FilterValidity.ThreeDays,
          onChange: () => setFilterValidity(FilterValidity.ThreeDays)
        },
        {
          key: FilterValidity.OneWeek,
          label: translation[FilterValidity.OneWeek],
          checked: filterValidity === FilterValidity.OneWeek,
          onChange: () => setFilterValidity(FilterValidity.OneWeek)
        },
        {
          key: FilterValidity.OneMonth,
          label: translation[FilterValidity.OneMonth],
          checked: filterValidity === FilterValidity.OneMonth,
          onChange: () => setFilterValidity(FilterValidity.OneMonth)
        }
      ]
    },
    {
      id: 'assigned',
      header: translation.assigned,
      type: 'radio',
      isClearDisabled: filterAssigned === null,
      onClear: () => setFilterAssigned(null),
      items: [
        {
          key: FilterAssignedState.Unassigned,
          label: translation.unassigned,
          checked: filterAssigned === FilterAssignedState.Unassigned,
          onChange: () => setFilterAssigned(FilterAssignedState.Unassigned)
        },
        {
          key: FilterAssignedState.Assigned,
          label: translation.assigned,
          checked: filterAssigned === FilterAssignedState.Assigned,
          onChange: () => setFilterAssigned(FilterAssignedState.Assigned)
        }
      ]
    }
  ];
};
